// extracted by mini-css-extract-plugin
export default {"layout":"login-wrapper_layout__A+yvR","logo":"login-wrapper_logo__YFzan"};